export class CreateGrupoTipoGarantiaRequest{
  public descripcion!:string
  public idGrupo!:number
  public idCantidadesTipoGarantia!:number
}
